type Args = {
  /** 検索ボタンがクリックされたときに呼び出される関数。 */
  onSearch: (searchValue: string) => void;
  /** 現在の検索フィールドの値。 */
  searchValue: string;
  /** 現在の検索フィールドの値を設定する関数。 */
  setSearchValue: (searchValue: string) => void;
};

type ReturnValue = {
  /** 現在の検索フィールドの値。 */
  searchValue: string;
  /** 検索フィールドの値が変更されたときに呼び出される関数。 */
  handleChangeSearchField: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /** 検索フィールドの値をクリアする関数。 */
  handleClickClearButton: VoidFunction;
  /** エンターキーが押されたときに検索を実行する関数。 */
  handleKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
};

/** 検索機能のカスタムフック。 */
export const useSearch = ({
  onSearch,
  searchValue,
  setSearchValue,
}: Args): ReturnValue => {
  const handleChangeSearchField = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSearchValue(event.target.value);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      onSearch(searchValue);
    }
  };

  const handleClickClearButton = () => {
    onSearch('');
  };

  return {
    searchValue,
    handleChangeSearchField,
    handleClickClearButton,
    handleKeyDown,
  };
};
